export const environment = {
  production: false,
  name: 'dev',
  awsLocationApiKey:
    'v1.public.eyJqdGkiOiI3YWYwM2MwMi1iMmEzLTQ4YWYtOTcyNC04MDdhZjNmZDk3ZDMifXhxfQ0pCU80xd6QJIW_BYeaClo6tJJ2Rz8iDFxxRuafPIVqW5dQVmuorJ5C-2x863RYsLOepnoNHbgGBtZT3UHAyBk1qS5BEbNn-mt0BuDlPA0cu0sJA_KFrGyCit1Buz2bvmGslXDDwHCUKer7b85hNYa0k9-AL8Qrm3rr3MscJgHt-8G-bYzv2XEBO9b1CN7Zi_iDjCIOcvVnfGyhpp4WaXU6H97yWk4g8ThmT3A5g0Vo1YGmmR9F_ch-1fmeSM0I7tC1tTDB3XLVG84_927Led4qx9F2WG4E-vfBnXFsCaggSw4bJ2fK8hMWvpG-vkBGBWN29jNgOmqOQhGtCaY.Y2MzMTcwNWYtZTgwMy00NGZlLWFiNGItNzVkMDFmMDM0Nzcy',
  apiUrl: 'https://api-portal-dev.vk.enbw.com',
  auth: {
    region: 'eu-central-1',
    userPoolId: 'eu-central-1_pG3pX78Uw', // Will be set by SST outputs
    userPoolClientId: '18cta696tpqnbe0jvgud22b4bh', // Will be set by SST outputs
  },
  featureFlags: {
    isSmallDVOfferCreationEnabled: true,
    isCompanyPortfolioFeaturesEnabled: true,
  },
}
